var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"list",staticClass:"list"},[_vm._t("default"),_c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('div',{staticClass:"loading"},[_vm._v("加载过程中")]):_vm._e(),(_vm.finished)?_c('div',{staticClass:"loading"},[_vm._v("已经到底了")]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }